<sc-modal #modal [closeButton]="false" id="{{idPrefix}}pending-changes-warning-modal" class="pending-changes-warning-modal">
    <div class="modal-content">
        <sc-title [content]="settings.title" type="h2"></sc-title>
        <p>
            {{settings.description}}
        </p>
        <div class="row">
            <sc-button type="primary" (onClick)="continue.emit()" class="col-6" id="{{idPrefix}}pending-changes-warning-modal-continuar">
                {{settings.labelContinue}}
            </sc-button>
            <sc-button type="secondary" (onClick)="cancel.emit()" class="col-6" id="{{idPrefix}}pending-changes-warning-modal-cancelar">
                {{settings.labelCancel}}
            </sc-button>
        </div>
    </div>
</sc-modal>